export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function blobToDataURL(blob) {
  return new Promise((resolve => {
    let a = new FileReader();
    a.onload = (e)=>{resolve(e.target.result);}
    a.readAsDataURL(blob);
  }));
}

export function dataURLtoBlob(dataurl) {
  let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type:mime});
}
